var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1102.235,
    height: 738.104,
    viewBox: "0 0 1102.235 738.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DSC_8983",
    d: "M-1598.123,763.032H-555.239v675.461c-30.227,26.575-121.364,54.632-244.645,62.218-87.569,5.388-192.867-42.739-301.056-22.685-102.319,18.965-201.536-35.2-283.937-16.312-59.061,13.542-112.2,13.178-153.312,3.494-24.811-5.846-39.326-7.167-59.933-26.715-24.907-23.629-47.53-120.91-27.837-151.979,42.125-85.965-4.674-181.39,5.094-228.421,11.913-57.358-24.707-116.028-30.322-149.347C-1668.515,805.935-1649.763,763.032-1598.123,763.032Z",
    transform: "translate(1657.474 -763.032)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieObject);
export default __webpack_public_path__ + "static/media/movie-object.1b792f6967de1841c13fe1be74dbb04f.svg";
export { ForwardRef as ReactComponent };